<template>
  <v-dialog v-model="verifyDialog" width="500" persistent>
    <v-card>
      <v-card-title class=" blue-purple-gradient">
        {{ header }}
      </v-card-title>

      <v-card-text class="pt-5">
        <div> {{ body }} </div>
        <div v-if="extraBody" class="mt-3">{{ extraBody }}</div>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn text @click.native="$emit('close-dialog')">
          {{ $t('actions.cancel') }}
        </v-btn>
        <v-btn :color="btnColor" depressed @click.native="actionFunction()">
          {{ action }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    verifyDialog: {
      type: [Boolean],
      required: true,
      default: false
    },
    btnColor: {
      type: [String],
      required: false,
      default: 'error'
    },
    header: {
      type: [String],
      required: true,
      default: ''
    },
    body: {
      type: [String],
      required: true,
      default: ''
    },
    extraBody: {
      type: [String],
      required: false,
      default: ''
    },
    action: {
      type: [String],
      required: true,
      default: ''
    },
    actionFunction: {
      type: [Function],
      required: true,
      default: function() {}
    },
    extraFunction: {
      type: [Function],
      required: false,
      default: function() {}
    }
  }
}
</script>
